import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { messages } from './InviteAuthRep.i18n';
import history from '../../history';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';

class InviteAuthStatementForm extends Component {
  onClickCancel = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
    history.push(this.props.prevRoute);
  }

  handleSubmitClick = () => {
    history.push('/contact-pin');
  }

  render() {
    return (
    <span>
      <div className="scrollbox mb-3"
        dangerouslySetInnerHTML={{ __html: this.props.signUpLegalStatement }}
        tabIndex="0"
      >
      </div>
      <form>
        <div className="button-area">
          <a
            type="button"
            role="button"
            tabIndex={0}
            data-qa-item="agree_button"
            data-toggle="modal"
            data-target="#agree"
            className="btn btn-primary"
            onClick={this.handleSubmitClick}
            aria-describedby="submitButtonDescription"
          >
          <FormattedMessage {...messages.button.agree} />
          </a>
          <a
            type="button"
            role="button"
            tabIndex={0}
            data-qa-item="cancel_button"
            className="btn btn-link"
            onClick={this.onClickCancel}
            aria-describedby="cancelButtonDescription"
          >
            <FormattedMessage { ...messages.button.cancel } />
          </a>
        </div>
      </form>
    </span>

    );
  }
}

InviteAuthStatementForm.propTypes = {
  dispatch: PropTypes.func,
  signUpLegalStatement: PropTypes.string,
  prevRoute: PropTypes.string,
};

const mapStateToProps = (state) => ({
  prevRoute: state.invitation.prevRoute,
});

export default connect(mapStateToProps)(injectIntl(InviteAuthStatementForm));